module.exports = __webpack_public_path__ + "img/page-404-image.e43d68bd.png";